import styled from "styled-components";

export const DateText = styled.div`
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0.1px;
  color: #9BADB1;
`;